/**
 * 分钟盘是否应自动纠到 clock live。
 *
 * - **进页**（`onEnter`）：一律纠到 clock live（含 5m），避免列表落到「下一档未开盘」。
 *   历史档用 `?hist=1`，由路由守卫跳过纠偏。
 * - **页内 auto-live**：
 *   - 非 5m：到期后自动纠正（settle 中由调用方拦截）
 *   - 5m：到期先停留展示结算；**仅裁决出结果后**（judged）再自动进实时盘，
 *     避免倒计时归零瞬间与交易区/结算区打架；手动「前往实时盘口」仍可用
 *
 * @param {number|string} intervalSec
 * @param {{ judged?: boolean, onEnter?: boolean }} [opts]
 */
export function shouldAutoNavigateUpdownToLive(intervalSec, opts = {}) {
  const interval = Number(intervalSec);
  if (!Number.isFinite(interval) || interval <= 0) return false;
  if (opts?.onEnter) return true;
  if (interval === 5 * 60) return Boolean(opts?.judged);
  return true;
}
